module.exports = __webpack_public_path__ + "static/media/theme-new-arrivals.cc0cbba6.svg";